export default {
	route: {
		lnbasesetting: {
			lnbasesetting: '基础设置',
			shopstalls: '食堂管理',
			superstore: '超市管理',
			superindex: '超市收银',
			dangkou: '档口管理',
			label: '标签管理',
			machinemanage: '设备管理',
			uploadplate: '上传空托盘',
			machinerole: '权限管理',
			merchantset: '商家参数',
			table: '餐桌管理',
			yuding: '查询预订信息',
			businesstime: '营业时间',
			timeslot: '餐次时段',
			ordermealset: '订餐设置',
			wechartsmallset: '订餐设置',
			gongzhonghaoset: '公众号设置',
			othertype: '其他Appid设置',
			jiliangdanwi: '计量单位',
			paymethodset: '基础配置',
			thirdbase: '第三方基础配置',
			effective: '数据权限',
			delivery: '配送方式',
			zhifu: '支付方式配置',
			specialDevicebind: '设备绑定(特殊)',
			role: '角色',
			lunbo: '轮播图',
			zidingyi: '自定义栏目(多商家)',
			guanggao: '广告图',
			message: '通知模板',
			tuijian: '推荐菜品',
			koukuan: '扣款顺序'
		},
		menudish: {
			menudish: '菜品菜谱',
			yuancailiaosahngoin: '原材料和商品',
			yuancailiao: '原料/商品',
			yuanliaodaoruyichang: '原料导入异常记录',
			yingyangsu: '营养素信息',
			yinshi: '饮食详情',
			shangpin: '商品',
			dishestype: '菜品类别',
			disheszaolei: '菜品灶类',
			dishesbiaoqian: '菜品编号',
			dishes: '菜品',
			taocan: '套餐',
			caipu: '菜谱',
			tag: '菜品标签',
			detail: '菜谱详情',
			kouwei: '菜品口味',
			enterCaipin: '菜品录入',
			liuyangji: '留样机详情',
			liuyangjilu: '留样记录',
			weiliuyang: '食堂未留样菜品'
		},
		Business: {
			audit: '商户审核',
			shopName: '商户汇总'
		},
		ordering: {
			ordering: '订单中心',
			orderdetail: '订单明细',
			orderall: '订单汇总',
			peisongdetail: '配送明细',
			dishbiaoqian: '菜品标签',
			dingcanyuantongji: '订餐员统计',
			tradedetail: '交易明细',
			ordertuikuan: '订单退款记录',
			yichang: '异常订单',
			baocan: '报餐明细',
			outOrdsum: '外部消费记录',
			ordershenhe: '退款审核'
		},
		marketing: {
			marketing: '营销中心',
			youhui: '优惠',
			timelimit: '消费规则',
			jifen: '积分换购',
			hongbao: '红包设置',
			repaidgift: '充值配置规则',
			managerule: '管理费规则',
			historyguize: '历史规则',
			xiaofeixingwei: '消费行为分析',
			huiyuanqingkuang: '会员情况分析',
			coupon: '优惠券',
			hongbaojilu: '领取记录',
			dikou: '积分抵扣规则',
			cancelorder: '退款规则',
			jiucanrule: '就餐权限',
			jifenhuoqu: '积分获取规则',
			cqguanli: '餐券管理',
			cqpeizhi: '餐券配置',
			cqmingxi: '餐券明细',
			cqfasong: '餐券发送日志'
		},
		notice: {
			notice: '通知中心',
			noticeruleset: '规则设置',
			noticetempory: '临时通知',
			noticehistory: '历史通知',
			tousu: '投诉建议',
			noticerulesetNew: '通知规则',
			noticeTemplate: '通知模板'

		},
		personal: {
			personal: '用户中心',
			renyuaninfo: '人员资料',
			organization: '组织架构',
			positioninfo: '位置信息',
			rechargewithdrawals: '充值取款',
			personal1: '人员信息',
			detail: '人员详情',
			chongzhi: '账户充值',
			butie: '补贴充值',
			jilu: '充值记录',
			chongzhiSum: '充值汇总',
			withdrawaljilu: '取款记录',
			withdrawalSum: '取款汇总',
			tuikuan: '退款',
			tuikuanrecords: '销户退款记录',
			linshi: '临时人员',
			personallabel: '人员标签管理',
			position: '职位职称',
			psntype: '人员类别',
			sick: '慢性病',
			set: '基础设置',
			personalSum: '个人汇总',
			deptSum: '组织汇总',
			psnTypeSum: '人员类别汇总',
			operatorSum: '操作员汇总',
			tradetypeSum: '充值交易类型汇总',
			chongzhituikuan: '充值退款记录',
			medicalreport: '体检报告',
			pldaorujieguo: '批量导入结果',
			fangke: '访客人员',
			kapianbangding: '卡片绑定',
			zhanghuqingkong: '账户清空记录',
			kpkouchujilu: '卡片扣除费用记录',
			logOut: '人员注销'
		},
		account: {
			accountCenter: '账户',
			accountino: '账户信息',
			plbukouyichang: '批量补扣异常信息列表'
		},
		healthCenter: {
			healthCenter: '健康中心',
			healthpersonal: '健康档案',
			medicalreport: '体检报告',
			healthpersonalDetail: '健康信息详情',
			peican: '营养配餐',
			healthcaipu: '健康菜谱',
			foodanalysis: '摄入分析',
			pianshianalysis: '偏食分析',
			analysisdetail: '详情分析',
			informationsubscription: '营养科普',
			healthadvicedetail: '营养科普详情'
		},
		caigouzhongxin: {
			caigouzhongxin: '采购中心',
			gongyinshang: '供应商',
			gongyinshangjibie: '供应商级别',
			caigouplan: '采购计划',
			caigougenerate: '采购',
			purchaselistDetail: '采购计划详情',
			caigousettlement: '采购订单',
			productplan: '生产计划生成',
			caigouOrdDetail: '采购订单详情',
			supplierDetail: '供应商资质',
			emaillist: '采购通知记录'
		},
		kucunzhongxin: {
			kucunzhongxin: '库存中心',
			depotManage: '库存',
			warehousing: '入库',
			warehousedetail: '入库单',
			importresult: '查看导入入库单结果',
			purchasestorage: '采购入库',
			returnstorage: '退料入库',
			outofstock: '出库',
			outhousedetail: '出库单',
			pickoutstock: '领料出库',
			returnoutstock: '退货出库',
			damageoutstock: '报损出库',
			stock: '仓库库存/配置',
			checkstock: '库存盘点',
			stockdetail: '库存详情',
			materialType: '原材料类别',
			basesetting: '基础配置',
			unit: '计量单位',
			material: '原料/商品',
			materialdetail: '原材料详情',
			pandian: '盘点'
		},
		baobiaozhongxin: {
			baobiaozhongxin: '报表中心',
			tradedetail: '流水详情',
			tradesum: '消费汇总',
			tradesumByDept: '组织汇总',
			tradesumByPsnType: '人员类别汇总',
			tradesumByCanteen: '食堂档口汇总',
			tradesumByMachine: '设备汇总',
			tradesumByPersonal: '个人消费汇总',
			tradesumByNuclearmode: '核销方式汇总',
			statisticaltable: '人员消费情况统计',
			statisticaltableByCaipin: '菜品消费统计表',
			statisticaltableByCanci: '就餐时段消费统计表',
			statisticaltableByPerson: '人员消费统计表',
			incomesum: '收支汇总',
			deptpaymentsum: '按组织收支汇总',
			datepaymentsum: '按日期收支汇总',
			psnpaymentsum: '按人员收支汇总',
			visitor: '访客盘汇总',
			visitorflowdetailpage: '访客盘消费流水表',
			visitorsum: '访客盘消费统计',
			getRepVisitorMenuPage: '访客盘菜品销售汇总',
			shouzhi: '部门区域消费表',
			historybal: '历史余额',
			caipinxiaoshouSum: '菜品销售汇总',
			salasAnalysis: '人员消费情况分析表',
			operatorCount: '操作员统计表',
			personchangecard: '人员换卡记录表',
			sysOperation: '系统运行情况表',
			peoplecardsum: '人员办卡汇总',
			peoplechangecard: '人员换卡记录表',
			deptcard: '部门发卡汇总表',
			shuikongsum: '水控查询',
			shuikongdetail: '水控明细',
			shuikonghuizong: '水控汇总',
			butiesum: '按就餐发放补贴',
			quanqijiucan: '人员就餐情况分析表',
			jiucanqingkuang: '就餐分析表',
			jiucanpeopledetail: '人员就餐明细',
			xfjliushui: '流水表',
			xfjsum: '消费汇总表',
			xfjdishsum: '菜品销售汇总表',
			xfj: '消费机'
		},
		// 数据大屏
		dataHunter: {
			dataHunter: '数据大屏'
		},
		coupon: {
			canquan: ''
		},
		dashboard: '首页',
		documentation: '文档',
		guide: '引导页',
		permission: '权限测试页',
		rolePermission: '角色权限',
		pagePermission: '页面权限',
		directivePermission: '指令权限',
		icons: '图标',
		components: '组件',
		tinymce: '富文本编辑器',
		markdown: 'Markdown',
		jsonEditor: 'JSON 编辑器',
		dndList: '列表拖拽',
		splitPane: 'Splitpane',
		avatarUpload: '头像上传',
		dropzone: 'Dropzone',
		sticky: 'Sticky',
		countTo: 'Count To',
		componentMixin: '小组件',
		backToTop: '返回顶部',
		dragDialog: '拖拽 Dialog',
		dragSelect: '拖拽 Select',
		dragKanban: '可拖拽看板',
		charts: '图表',
		keyboardChart: '键盘图表',
		lineChart: '折线图',
		mixChart: '混合图表',
		example: '综合实例',
		nested: '路由嵌套',
		menu1: '菜单1',
		'menu1-1': '菜单 1-1',
		'menu1-2': '菜单 1-2',
		'menu1-2-1': '菜单 1-2-1',
		'menu1-2-2': '菜单 1-2-2',
		'menu1-3': '菜单 1-3',
		menu2: '菜单 2',
		Table: 'Table',
		dynamicTable: '动态 Table',
		dragTable: '拖拽 Table',
		inlineEditTable: 'Table 内编辑',
		complexTable: '综合 Table',
		tab: 'Tab',
		form: '表单',
		createArticle: '创建文章',
		editArticle: '编辑文章',
		articleList: '文章列表',
		errorPages: '错误页面',
		page401: '401',
		page404: '404',
		errorLog: '错误日志',
		excel: 'Excel',
		exportExcel: '导出 Excel',
		selectExcel: '导出 已选择项',
		mergeHeader: '导出 多级表头',
		uploadExcel: '上传 Excel',
		zip: 'Zip',
		pdf: 'PDF',
		exportZip: 'Export Zip',
		theme: '换肤',
		clipboardDemo: 'Clipboard',
		i18n: '国际化',
		externalLink: '外链',
		profile: '个人中心'
	},
	shijian: {
		chuangjianshijian: '创建时间',
		genxinshijian: '更新时间'
	},
	noticeDetail: {
		select: '选择',
		number: '编号',
		name: '姓名',
		phone: '手机号',
		icard: '身份证',
		orgFullName: '所属机构'
	},
	noticeCon: {
		number: '请输入编号',
		name: '请输入姓名',
		phone: '请输入手机号',
		icard: '请输入身份证',
		orgFullName: '所属机构'
	},

	role: {
		roleid: '角色id',
		roleName: '角色名称',
		roleDesc: '描述',
		menuList: '菜单权限',
		effname: '范围名称',
		userId: '操作员id',
		username: '用户名',
		realName: '真实姓名',
		phone: '手机号',
		role: '角色',
		canteenEffname: '食堂范围',
		custEffname: '人员范围',
		dishesEffname: '菜品范围',
		password: '密码',
		avatar: '头像'
	},
	menudish: {
		yinshi: '饮食详情',
		bianhao: '编号',
		name: '名称',
		caipuName: '菜谱名称',
		bigType: '食材大类',
		littleType: '食材小类',
		nutritionName: '营养信息名称',
		source: '来源',
		update: '修改',
		del: '删除',
		write: '写盘',
		detail2: '详情',
		creattime: '创建时间',
		updatetime: '更新时间',
		starttime: '开始时间',
		endtime: '结束时间',
		unit: '计量单位',
		button: '操作',
		productname: '名称',
		type: '菜品类型',
		kitchen: '菜品灶类',
		price: '价格',
		boxprice: '餐盒费',
		totalprice: '总价',
		weight: '计重',
		image: '图片',
		tag: '菜品标签',
		des: '简介',
		detail: '图文详情',
		yuanliao: '原料/商品',
		tuijian: '推荐菜品',
		yingyang: '菜品营养',
		dishs: '包含菜品',
		dish: '菜品',
		bindType: '营养信息类型',
		bind: '营养信息绑定',
		canteen: '食堂',
		booth: '档口',
		shitang: '食堂/档口',
		time: '起止时间',
		time2: '选择时间',
		time3: '选择时段',
		date: '日期',
		canci: '餐次',
		zaocan: '早餐',
		wancan: '晚餐',
		wucan: '午餐',
		kucun: '库存',
		sale: '折扣',
		xiangou: '限购数量',
		chief: '制作厨师',
		pinyinInitials: '名称首字母',
		pinyinFull: '名称全拼',
		kouwei: '菜品口味',
		moren: '是否默认',
		taocan: '套餐',
		product: '商品',
		caiputype: '菜谱类型',
		gongyingliang: '供应数量',
		salePrice: '优惠价格',
		saleTime: '优惠时间',
		caipu: '菜谱',
		shitangst: '食堂',
		shangjia: '上架',
		xiajia: '下架'
	},
	shitang: {
		shitangname: '食堂名称',
		fuzeren: '负责人',
		lianxidianhua: '手机号',
		jindu: '经度',
		weidu: '纬度',
		ifteyue: '是否为特约商户'
	},
	dangkou: {
		dangkouname: '档口名称',
		dangkoufuzeren: '负责人',
		lianxidianhua: '手机号',
		dangkouSearch: '档口名称'
	},
	biaoqian: {
		biaoqianname: '标签名称',
		biaoqianid: '标签id',
		shangjiaid: '商家id',
		del: '是否删除',
		id: 'id'
	},
	machine: {
		merchantId: '商家id',
		diningId: '食堂id',
		mchId: '设备编号',
		mchName: '设备名称',
		mchType: '设备类型',
		mchip: '设备ip',
		machinesn: '设备sn码'
	},
	macPrinters: {
		priId: '打印机Id',
		priName: '打印机名称',
		priStatus: '打印机状态',
		machineId: '设备编号',
		machineSn: '设备SN码',
		priKey: '打印机Key',
		canteen: '食堂',
		dangkou: '档口',
		caipu: '菜谱',
		effName: '人员范围'
	},
	caozuo: {
		addnew: '新增',
		shanchu: '删除',
		xiugai: '修改',
		xiangxixinxi: '详细信息'
	},
	navbar: {
		dashboard: '首页',
		github: '项目地址',
		logOut: '退出登录',
		profile: '个人中心',
		theme: '换肤',
		size: '布局大小',
		editpwd: '修改密码',
		oldpwd: '请输入旧密码',
		newpwd: '请输入新密码'
	},
	merchantbasesetting: {
		shitangname: '食堂名称',
		canzhuomingcheng: '餐桌名称',
		baojianmingcheng: '包间名称',
		baojianbianhao: '包间编号',
		shopstallName: '档口名称',
		erweima: '二维码',
		beizhu: '备注',
		effName: '范围名称',
		renyuantype: '人员类别',
		bumen: '部门范围',
		dishes: '菜品范围',
		weekMenuRecipeId: '一周菜谱',
		shitangfanwei: '食堂范围',
		dangkoufanwei: '档口范围',
		shitangdangkou: '食堂档口',
		shitangcaipu: '食堂菜谱',
		changePeisong: '管理配送方式',
		peisong: '配送方式',
		bianhao: '编号',
		snCode: '设备sn码',
		cabinet: '取餐柜',
		cabinetId: '取餐柜id',
		ordId: '订单编号',
		status: '状态2',
		active: '状态1',
		cabinetCode: '柜门编号',
		cabinetCount: '柜门数量',
		shebeiBianhao: '设备编号',
		shebeiName: '设备名称',
		shebeiIP: '设备IP',
		shebeiAddr: '安装地址',
		netmask: '子网掩码',
		shebeiMac: 'mac地址',
		gateway: '网关',
		firstDNS: '首选DNS',
		secondDNS: '备用DNS',
		taocan: '套餐范围',
		product: '商品范围',
		userType: '人员取集',
		grade: '会员范围',
		effType: '范围种类',
		tablePerNum: '餐桌可坐人数',
		baojianPerNum: '包间可坐人数',
		ifAstrictQuotaTime: '是否限额限次',
		ifQuotaLimit: '是否限额',
		ifTimeLimit: '是否限次',
		ifDiscount: '是否打折',
		ifUseCallNum: '是否启用叫号',
		caipu: '菜谱',
		sendCaipu: '下发菜谱',
		sendAllcaipu: '批量下发所有菜谱',
		sendPartcaipu: '批量下发部分菜谱',
		koukuan: '扣款顺序',
		koukuanway: '请选择扣款顺序',
		koukuansort: '当前排序'
	},
	login: {
		title: '系统登录',
		logIn: '登录',
		username: '账号',
		password: '密码',
		any: '随便填',
		thirdparty: '第三方登录',
		thirdpartyTips: '本地不能模拟，请结合自己业务进行模拟！！！'
	},
	documentation: {
		documentation: '文档',
		github: 'Github 地址'
	},
	BusinessInfo: {
		// 商户审核
		canteenName: '食堂或餐厅名称',
		linkman: '联系人姓名',
		linkmanNumber: '联系人手机号',
		adminName: '管理员名称',
		password: '密码',
		email: '邮箱',
		merchantName: '公司名称',
		userCount: '授权用户数',
		wechat: '微信号',
		address: '商户地址',
		endTime: '授权截至日期',
		startTime: '入驻日期'
	},
	permission: {
		changeinfo: '验证卡信息',
		rearsyscard: '读取系统卡',
		psntype: '人员类别',
		psnTypeName: '类别名称',
		addRole: '新增角色',
		editPermission: '编辑权限',
		roles: '你的权限',
		switchRoles: '切换权限',
		putName: '编辑',
		delete: '删除',
		confirm: '确定',
		cancel: '取消',
		shangji: '上级名称',
		allname: '全称',
		fuze: '组织负责人',
		fuzetel: '负责人手机号',
		name: '姓名',
		name2: '名称',
		remarks: '备注',
		nation: '民族',
		jigou: '所属组织',
		jigouname: '组织名称',
		weizhiname: '位置名称',
		shangjiweizhi: '上级位置',
		pname: '姓名',
		phone: '手机号',
		sex: '性别',
		email: '邮箱',
		position: '职位',
		featuresbuildstatus: '生成状态',
		featuresbuildstatustime: '特征值生成时间',
		serialNum: '卡物理号',
		cardStatus: '卡状态',
		positionlevel: '职位等级',
		positionlevel2: '职位级别',
		kahao: '卡号',
		kahaowuli: '卡物理号',
		level: '会员等级',
		photo: '照片',
		zhiwen: '指纹',
		jingmai: '静脉',
		hongmo: '虹膜',
		zhangwen: '掌纹',
		nicheng: '昵称',
		openid: 'openid',
		from: '来源',
		address: '地址',
		homeAddress: '家庭地址',
		shenfenzheng: '身份证号',
		pwd: '密码',
		bianhao: '编号',
		wechat: '微信',
		dd: '钉钉',
		qq: 'qq',
		jjname: '紧急联系人',
		jjphone: '紧急联系手机号',
		jjcard: '紧急联系人身份证',
		huaiyun: '是否怀孕',
		xiong: '胸围',
		yao: '腰围',
		year: '年龄',
		jiehun: '婚否',
		huaiyundate: '怀孕日期',
		sick: '慢性病',
		des: '饮食医嘱',
		iszhuyuan: '是否住院',
		zhuyuanDate: '最近住院日期',
		zhuyuanreslut: '住院诊断结果',
		birth: '生日',
		age: '年龄',
		height: '身高',
		weight: '体重',
		positiontime: '入职时间',
		zhicheng: '职称',
		zhichenglevel: '职称等级',
		bianzhi: '编制',
		hetongtime: '合同签订时间',
		hetongendtime: '合同到期时间',
		yue: '账户总余额',
		personalyue: '个人钱包余额',
		butie: '补贴钱包余额',
		jifen: '积分',
		youxiaoqi: '卡有效期',
		status: '账户状态',
		yajin: '押金',
		gongben: '工本费',
		faka: '发卡',
		dongjie: '冻结',
		jiedong: '解冻',
		zhuxiao: '注销',
		huanka: '换卡',
		guashi: '挂失',
		jiegua: '解挂',
		duka: '读卡',
		piliang: '批量充值',
		type: '类型',
		chongzhi: '充值',
		jine: '剩余金额',
		chongzhijine: '充值金额',
		chongzhitype: '充值类型',
		chongzhimethods: '充值方式',
		chongzhiState: '充值状态',
		chongzhitime: '充值时间',
		operator: '操作员',
		qukuan: '取款',
		qukuanAmount: '取款金额',
		qukuanType: '取款类型',
		qukuanState: '取款状态',
		qukuanTime: '取款时间',
		refundAmount: '退款金额',
		refundType: '退款类型',
		refundTime: '退款时间',
		chexiao: '撤销充值',
		qukuanrule: '取款规则设置',
		chexiaoxf: '撤销消费',
		xiaofeijine: '消费金额',
		zhifutype: '支付方式',
		xiaofeitime: '消费时间',
		addRule: '添加规则',
		kaidan: '开单',
		plkaidan: '批量开单',
		downloadTable: '下载模板Excel',
		importExcel: '导入Excel',
		butiejine: '补贴金额',
		butieendtime: '补贴到期时间',
		butieshangxian: '补贴账户上限',
		butiestarttime: '补贴到账时间',
		butieChongzhi: '补贴充值',
		butieQukuan: '补贴取款',
		hongbao: '红包',
		caozuojine: '操作金额',
		shijian: '操作类型',
		code: '编码',
		jikou: '忌口',
		yishi: '宜食',
		selectPerson: '选择人员',
		selectOrg: '选择组织架构',

		custNum: '人员编号',
		custName: '人员姓名',
		orgFullName: '组织全称',
		totalNum: '总次数',
		totalMoney: '总金额',
		minWalletBalLimit: '个人钱包允许最低余额',
		minSubBalLimit: '补贴钱包允许最低余额',
		minRedBalLimit: '红包允许最低余额',
		waterWalletBal: '水控个人钱包余额',
		waterSubsidyBal: '水控补贴钱包余额'
	},
	guide: {
		description: '引导页对于一些第一次进入项目的人很有用，你可以简单介绍下项目的功能。本 Demo 是基于',
		button: '打开引导'
	},
	components: {
		documentation: '文档',
		tinymceTips: '富文本是管理后台一个核心的功能，但同时又是一个有很多坑的地方。在选择富文本的过程中我也走了不少的弯路，市面上常见的富文本都基本用过了，最终权衡了一下选择了Tinymce。更详细的富文本比较和介绍见',
		dropzoneTips: '由于我司业务有特殊需求，而且要传七牛 所以没用第三方，选择了自己封装。代码非常的简单，具体代码你可以在这里看到 @/components/Dropzone',
		stickyTips: '当页面滚动到预设的位置会吸附在顶部',
		backToTopTips1: '页面滚动到指定位置会在右下角出现返回顶部按钮',
		backToTopTips2: '可自定义按钮的样式、show/hide、出现的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素',
		imageUploadTips: '由于我在使用时它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用的话，优先还是使用官方版本。'
	},

	table: {
		dynamicTips1: '固定表头, 按照表头顺序排序',
		dynamicTips2: '不固定表头, 按照点击顺序排序',
		dragTips1: '默认顺序',
		dragTips2: '拖拽后顺序',
		title: '标题',
		name: '名称',
		linshiname: '临时人员名称',
		couponName: '优惠券名称',
		tasteName: '名称',
		custName: '姓名',
		importance: '重要性',
		type: '类型',
		remark: '点评',
		search: '查询',
		chaxun: '查询',
		listQuery: '高级查询',
		add: '新增',
		caipin: '标签',
		export: '导出',
		reviewer: '审核人',
		id: '编号',
		date: '时间',
		author: '作者',
		readings: '阅读数',
		status: '状态',
		actions: '操作',
		edit: '修改',
		publish: '发布',
		draft: '草稿',
		pldelete: '批量删除',
		delete: '删除',
		cancel: '取 消',
		confirm: '确 定',
		detail: '详情',
		creattime: '创建时间',
		updatetime: '更新时间',
		save: '保存',
		button: '操作',
		next: '下一步',
		prev: '上一步',
		return: '返回',
		labelMgt: '标签管理',
		koukuanadd: '设置扣款顺序',
		noticetype: '通知类型',
		xiaohu: '销户',
		yanqi: '延期',
		tingyong: '停用',
		email: '邮件通知'
	},
	example: {
		warning: '创建和编辑页面是不能被 keep-alive 缓存的，因为keep-alive 的 include 目前不支持根据路由来缓存，所以目前都是基于 component name 来进行缓存的。如果你想类似的实现缓存效果，可以使用 localStorage 等浏览器缓存方案。或者不要使用 keep-alive 的 include，直接缓存所有页面。详情见'
	},
	errorLog: {
		tips: '请点击右上角bug小图标',
		description: '现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。',
		documentation: '文档介绍'
	},
	excel: {
		export: '导出',
		selectedExport: '导出已选择项',
		placeholder: '请输入文件名(默认excel-list)'
	},
	zip: {
		export: '导出',
		placeholder: '请输入文件名(默认file)'
	},
	pdf: {
		tips: '这里使用   window.print() 来实现下载pdf的功能'
	},
	theme: {
		change: '换肤',
		documentation: '换肤文档',
		tips: 'Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。'
	},
	tagsView: {
		refresh: '刷新',
		close: '关闭',
		closeOthers: '关闭其它',
		closeAll: '关闭所有'
	},
	settings: {
		title: '系统布局配置',
		theme: '主题色',
		tagsView: '开启 Tags-View',
		fixedHeader: '固定 Header',
		sidebarLogo: '侧边栏 Logo'
	},
	notice: {
		content: '通知内容',
		type: '通知方式',
		bianhao: '编号',
		name: '名称'
	},
	marketing: {
		max_time: '上限次数',
		maxCardTime: '刷卡上限次数',
		maxFaceTime: '刷脸上限次数',
		ifFirstDiscount: '是否首次打折',
		max_amount: '上限金额',
		gainEff: '领取人员范围',
		couponStatus: '优惠券状态',
		firstAmount: '第一次金额',
		secondAmount: '第二次金额',
		thirdAmount: '第三次及以后金额',
		discount: '折扣',
		quotaType: '限制类型',
		paytype: '支付方式',
		shitang: '食堂',
		maxDiscountAmount: '折扣上限金额',
		eff: '生效范围',
		canteenEff: '适用食堂类范围',
		interval: '时间段',
		ruleName: '规则名称',
		max: '金额上限',
		min: '金额下限',
		donate: '赠送',
		donateType: '赠送类型',
		donateAmount: '赠送金额',
		donateRatio: '赠送比例(例:0.6)',
		expense: '管理费',
		expenseAmount: '管理费金额',
		expenseRatio: '管理费比例(例:0.6)',
		expenseType: '管理费类型',
		sort: '优先级',
		couponName: '优惠券名称',
		couponType: '优惠券类型',
		discountsAmount: '优惠金额',
		discountsRatio: '折扣比例(例:0.6)',
		minAmount: '生效金额',
		grantWay: '发放方式',
		validityType: '有效期类型',
		expireTime: '失效日期',
		expireHour: '有效时间',
		backgroundImg: '背景图',
		totalAmount: '红包总金额',
		totalNum: '红包总数	',
		fixedAmount: '固定金额',
		time: '起始时间',
		envelopType: '红包类型',
		gotTime: '获取次数',
		touchAmount: '触发金额',
		grantType: '发放类型',
		envelopStatus: '红包状态',
		startDate: '开始时间',
		endDate: '结束时间',
		fafang: '发放',
		hongbaoDetail: '红包记录',
		recordId: '编号',
		envelopId: '红包编号',
		custId: '人员编号',
		amount: '领取金额',
		couponguanli: '餐券管理'
	},
	orderdetail: {
		// 订单明细
		ordId: '订单号',
		consumeId: '订单号',
		OutordId: '第三方消费订单号',
		ordTime: '下单时间',
		ordStatus: '订单状态',
		payType: '支付方式',
		payState: '支付状态',
		deliveryAddr: '配送地址',
		tradeNo: '交易编号',
		tradeName: '交易人',
		orgName: '所属部门',
		tradeTime: '交易时间',
		tradeType: '交易类型',
		deliveryFee: '配送费',
		amount: '订单总金额',
		realAmount: '实际付款金额',
		custNum: '订餐人编号',
		custName: '订餐人姓名',
		deliveryType: '配送方式',
		remark: '订单备注',
		payTime: '支付时间',
		orgFullName: '组织全称',
		placeOrdName: '联系人',
		placeOrdMobile: '手机号',
		canteenName: '食堂',
		shopstallName: '档口',
		sourceType: '订单来源',
		printOrd: '打印订单',
		print: '打印',
		mchNum: '设备编号',
		mchName: '设备名称',
		machineSn: '设备SN码',
		nuClearMode: '核身方式',
		ifOnline: '在线离线支付',
		consumMode: '消费模式',
		medishDetail: '菜品明细',
		Preview: '预览',
		accBal: '账户总余额',

		// 配送明细
		ordGoodsDate: '订单日期',
		intervalName: '餐次',
		custId: '订餐人id',
		ordDetail: '订单明细',
		money: '金额',
		deliveryStaff: '配送员',
		deliveryStaffTel: '配送员手机号',
		deliveryState: '配送状态'
	},
	tradedetail: {
		flowNum: '流水号',
		custNum: '人员编号',
		cardNum: '卡号',
		custName: '人员姓名',
		depositAmount: '存入',
		shouldAmount: '应收',
		actualAmount: '实收',
		walletPay: '个人钱包支出',
		subsidyPay: '补贴钱包支出',
		totalPay: '总支出',
		accBal: '账户总余额',
		accPayCount: '账户交易次数',
		tradeType: '交易类型',
		tradeTime: '交易时间',
		payType: '交易方式',
		mchNum: '设备编号',
		mchType: '设备类型',
		operatorName: '操作员姓名',
		operator: '操作员',
		deliveryFee: '配送费',
		amount: '订单总金额',
		placeOrdName: '联系人',
		placeOrdMobile: '手机号',
		realAmount: '实际付款金额',
		deliveryType: '配送方式',
		remark: '订单备注',
		payTime: '支付时间',
		orgFullName: '组织全称',
		canteenName: '食堂',
		shopstallName: '档口',
		sourceType: '订单来源',
		psnType: '人员类别',
		nuClearMode: '核身方式'
	},
	noticeRuleset: {
		ruleType: '通知类型',
		informType: '通知方式',
		informContent: '通知内容',
		informRuleRanges: '适用人员范围',
		irrType: '适用人群类型',
		irrTypeContent: '通知人群类型内容'
	},
	noticehistory: {
		informStatime: '通知时间',
		informContent: '通知内容',
		informType: '通知方式',
		isToAll: '通知全部人员',
		informRanges: '通知人员'
	},
	ordersum: {
		orderDate: '订单日期',
		caipinName: '菜品或商品名称',
		ordersum: '数量',
		disheszaolei: '灶类',
		canteenName: '食堂',
		dangkouname: '档口',
		canci: '餐次',
		machNum: '设备编号',
		sumStyle: '汇总方式'
	},
	tradesum: {
		// 充值汇总
		rechargeDate: '充值日期',
		tradeType: '充值交易类型',
		payType: '充值支付方式',
		personalRechargeWallet: '个人钱包实际变动金额',
		clearWallet: '个人钱包清空金额',
		walletBalGift: '个人钱包充值赠送',
		personalWallet: '个人账户到账金额',
		rechargeSubsidy: '实际补贴充值金额',
		clearSub: '补贴清空',
		subsidyBalGift: '补贴赠送金额',
		subsidy: '补贴账户到账金额',
		clearRed: '红包清空金额',
		redEnvelopeGift: '红包赠送金额',
		manageCost: '管理费',

		// 按食堂汇总
		canteenName: '食堂',
		dangkouName: '档口',
		bumenName: '部门名称',
		tradeDate: '消费日期',
		zaocanTime: '早餐次数',
		zaocanNum: '早餐人次',
		zaocanMoney: '早餐金额',
		zaocanButiemoney: '早餐补贴金额(元)',
		zaocanOnceButiemoney: '早餐单次补贴金额(元)',
		wucanTime: '午餐次数',
		wucanNum: '午餐人次',
		wucanMoney: '午餐金额',
		wucanButiemoney: '午餐补贴金额(元)',
		wucanOnceButiemoney: '午餐单次补贴金额(元)',
		xiawuchaTime: '下午茶次数',
		xiawuchaNum: '下午茶人次',
		xiawuchaMoney: '下午茶金额',
		xiawuchaButiemoney: '下午茶补贴金额(元)',
		xiawuchaOnceButiemoney: '下午茶单次补贴金额(元)',
		wancanTime: '晚餐次数',
		wancanNum: '晚餐人次',
		wancanMoney: '晚餐金额',
		wancanButiemoney: '晚餐补贴金额(元)',
		wancanOnceButiemoney: '晚餐单次补贴金额(元)',
		yexiaoTime: '夜宵次数',
		yexiaoNum: '夜宵人次',
		yexiaoMoney: '夜宵金额',
		yexiaoButiemoney: '夜宵补贴金额(元)',
		yexiaoOnceButiemoney: '夜宵单次补贴金额(元)',
		qitaTime: '其他时段次数',
		qitaNum: '其他时段人次',
		qitaMoney: '其他时段金额',
		qitaButiemoney: '其他时段补贴金额(元)',
		qitaOnceButiemoney: '其他时段单次补贴金额(元)',
		totalTime: '合计次数',
		totalNum: '合计人数',
		totalMoney: '合计金额',
		totalSub: '总补贴金额',
		valiTime: '有效期',

		// 按个人餐次消费汇总
		custNum: '人员编号',
		custId: '人员Id',
		custName: '人员姓名',
		orgFullName: '组织全称',
		cardType: '卡类别',
		totalPersonalWallet: '个人钱包消费合计',
		totalSubWallet: '补贴钱包消费合计',
		zaocanPersonalWallet: '早餐个人钱包消费',
		zaocanSubWallet: '早餐补贴钱包消费',
		zaocanTotalMoney: '早餐消费合计',
		wucanPersonalWallet: '午餐个人钱包消费',
		wucanSubWallet: '午餐补贴钱包消费',
		wucanTotalMoney: '午餐消费合计',
		wancanPersonalWallet: '晚餐个人钱包消费',
		wancanSubWallet: '晚餐补贴钱包消费',
		wancanTotalMoney: '晚餐消费合计',
		yexiaoPersonalWallet: '夜宵个人钱包消费',
		yexiaoSubWallet: '夜宵补贴钱包消费',
		yexiaoTotalMoney: '夜宵消费合计',
		qitaPersonalWallet: '其他个人钱包消费',
		qitaSubWallet: '其他补贴钱包消费',
		qitaTotalMoney: '其他消费合计',

		// 设备汇总
		mchNum: '设备编号',
		mchName: '设备名称',

		// 核身方式汇总
		nuClearModeName: '核身方式',

		// 人员类别汇总
		psnType: '人员类别',

		// 收支汇总
		zaocanConsum: '早餐时段消费',
		wucanConsum: '午餐时段消费',
		xiawuchaConsum: '下午茶时段消费',
		wancanConsum: '晚餐时段消费',
		yexiaoConsum: '夜宵时段消费',
		otherConsum: '其他时段消费',
		totalConsum: '总消费',
		saveMoney: '存款',
		revokeMoney: '取款',
		saveButie: '存补贴',
		revokeButie: '取补贴',
		sendMoney: '赠送金额',
		butieZero: '补贴清零',

		// 人员办卡统计
		recordType: '卡操作',
		custs: '人数',
		deposit: '办卡押金',
		productCost: '办卡工本费',

		// 菜品销售汇总
		caipinNo: '菜品/商品编号',
		caipinName: '菜品/商品名称',
		price: '菜品单价',
		zaocanNumber: '早餐数量',
		wucanNumber: '午餐数量',
		xiawuchaNumber: '下午茶数量',
		wancanNumber: '晚餐数量',
		yexiaoNumber: '夜宵数量',
		otherNumber: '其他时段数量',
		sumNumber: '总数量',
		sumMoney: '总金额',

		// 菜品价格分析
		shopNo: '商品编号',
		shopName: '商品名称',
		costPrice: '成本价',
		maoli: '毛利',

		// 菜品销售分析
		saleNum: '销售数量',
		saleMoneyxiaoji: '销售金额小计',
		costOnePrice: '成本单价',
		costMoneyxiaoji: '成本金额小计',
		caipinMaoli: '菜品毛利',
		caipinmaolixiaoji: '菜品毛利小计',

		// 人员卡务信息
		icard: '身份证号',
		mobile: '手机号',
		deptNo: '部门编号',
		renyuankahao: '人员卡号',
		cardState: '卡状态',
		zhuqianbaoBalance: '个人钱包余额',
		butieBalance: '补贴钱包余额',
		totalBalance: '总余额',
		endState: '到期状态',
		zhuqianbaoDate: '个人钱包有效期',
		butieDate: '补贴钱包有效期',

		// 销售情况分析表
		xiaofeiMoney: '消费金额',
		xiaofeiTimes: '消费次数',
		xiaofeiDetail: '消费明细',

		// 系统运行情况表
		tradeProName: '交易项目名称',
		produceTime: '发生次数',
		produceMoney: '发生金额'
	},
	shuikongsum: {
		// 水控明细
		custName: '姓名',
		custNum: '编号',
		cardNo: '卡号',
		machno: '机器编号',
		recdt: '刷卡时间',
		paySecond: '本次免费时长(秒)',
		payMoney: '本次消费额',
		personalYu: '个人钱包余额',
		subYu: '补贴钱包余额'
	},
	marcenter: {
		// 分页获取积分
		gainRuleName: '积分获取名称',
		gainRuleId: '积分获取id',
		gainType: '获取类型',
		donateType: '赠送类型',
		donatePoint: '赠送定额积分',
		donateRatio: '赠送积分比例(0~1)',
		effId: '适用人员范围',
		effName: '适用人员范围名称',
		upby: '更新人',
		pointRuleStatus: '积分启用状态',
		sort: '优先级'
	},
	pointtax: {
		// 分页抵扣积分
		offsetRuleId: '积分抵扣id',
		offsetRuleName: '积分抵扣名称',
		offsetAmount: '抵扣金额(分/1积分)',
		minAmount: '触发金额',
		pointRuleStatu: '抵扣规则状态',
		effId: '生效范围id',
		effName: '生效范围名称',
		sort: '优先级',
		crby: '创建人',
		crtime: '创建时间',
		upby: '更新人',
		uptime: '更新时间'
	},
	appletcaipu: {
		// 小程序推荐菜品
		canteenId: '食堂名称',
		dishesName: '推荐菜品名称'
	},

	// 报表查询条件
	reportQueryCon: {
		custId: '人员id',
		custNum: '人员编号',
		custName: '人员姓名',
		flowNum: '流水号',
		ordId: '订单号',
		tradeType: '交易类型',
		canteenId: '食堂',
		shopstallId: '档口',
		mchNum: '设备编号',
		mchName: '设备名称',
		psntype: '人员类别',
		ordState: '订单状态',
		payType: '支付方式',
		payState: '支付状态',
		deliveryType: '配送方式',
		dishesName: '菜品/商品名称',
		interval: '餐次',
		goodsType: '商品类型',
		ordName: '订餐人姓名',
		deliveryName: '配送员姓名',
		peisongState: '配送状态',
		price: '单价',

		nuClearMode: '核身方式',

		dishesId: '菜品/商品编号',

		mobile: '手机号',
		sex: '性别',
		featuresBuildStatus: '特征值生成状态',
		custState: '人员状态',

		sourceType: '订单来源',
		ordDate: '订单日期',
		ordTime: '下单时间',
		ifOnline: '在线离线支付',
		consumMode: '消费模式',
		machineSn: '设备SN码'
	},

	// 采购中心
	purchase: {
		// 供应商
		num: '编号',
		name: '供应商',
		address: '地址',
		contactPerson: '联系人',
		contactPhone: '手机号',
		email: '邮箱',
		deliveryType: '配送方式',
		supplyType: '供应类别',
		dingtalk: '钉钉',
		qq: 'QQ',
		wechart: '微信',
		status: '供应商状态',

		// 采购计划
		// 采购生产
		purId: '采购单号',
		purDate: '采购计划时间',
		purCanteen: '食堂',
		warehouse: '仓库',
		purStatus: '采购计划状态',
		operator: '操作员',
		puruser: '采购员',

		// 采购订单
		purOrdId: '采购订单号',
		ordStatus: '订单状态',
		errorReason: '失败原因',
		excelUrl: '文件地址',
		noticeStatus: '通知结果',
		noticeTime: '通知时间',
		noticeType: '通知类型',
		planId: '采购单号',
		supplierName: '供应商名称',
		crby: '操作员',
		startTime: '通知时间开始',
		endTime: '通知时间结束'
	},

	// 库存中心
	stock: {
		// 基础设置
		// 仓库管理
		num: '编号',
		name: '名称',
		warehouseName: '仓库名称',
		canteen: '食堂',
		admin: '负责人',
		username: '负责人用户名',
		realName: '负责人真实姓名',
		mobile: '手机号',

		// 计量单位
		unitName: '计量单位名称',
		rate: '换算比率(为多少g)',

		// 原材料
		materialName: '原材料名称',
		material: '原料/商品',
		bigType: '原料大类',
		littleType: '原料小类',
		nutritionName: '营养信息名称',
		referPrice: '采购价(默认价格)',
		allType: '原料类别',

		// 库存
		// 库存
		number: '数量',
		unit: '计量单位',
		materialType: '原材料类别',
		depotName: '仓库',
		depotNum: '库存数量',
		lowStockNumber: '最小库存数',
		highStockNumber: '最大库存数',
		stockState: '库存状态',
		birthday: '生产日期',
		baozhiqi: '保质期',
		endtime: '保质期截止日期',
		baozhiqiState: '保质期状态',
		batch: '批次编号',
		barCode: '条形码',

		// 入库
		// 入库
		inhouseOrdNum: '入库单号',
		inhouseDate: '入库时间',
		inhouseType: '入库类型',
		inhouseState: '入库状态',
		supplier: '供应商',
		totalMoney: '总金额',
		operator: '操作员',
		remark: '备注',
		keeperUserName: '仓库管理员',
		operaTime: '操作时间',
		purchaser: '采购员',

		// 入库单
		purchasePrice: '采购价(默认)',
		unitPrice: '进价',
		sumMoney: '金额',

		// 出库
		// 出库
		outhouseOrdNum: '出库单号',
		outhouseDate: '出库时间',
		outhouseType: '出库类型',
		outhouseState: '出库状态',
		fetchUserName: '领料人'

		// 出库单
	},

	// 操作员统计表
	operatorCount: {
		operator: '操作员',
		operaType: '操作类型',
		totalNum: '次数',
		totalMoney: '交易金额',
		totalDeposit: '押金',
		totalCost: '工本费'
	}
}
